<template>
    <v-dialog v-model="dialogModel" max-width="600" v-if="shouldAsk">
        <v-card>
            <div class="d-flex justify-center pt-5 pb-5">
                <v-icon size="100" :color="actionButtonColor">mdi-bell-ring</v-icon>
            </div>
            <v-card-text class="text-center subtitle-1">
                {{ translations.enable_notifications_question_text }}
            </v-card-text>
            <v-card-actions class="d-flex justify-space-around pb-10">
                <v-btn :color="actionButtonColor"
                       @click="askForPermission"
                       :loading="loading"
                       :class="getFontClasses(actionButtonColor)">
                    {{ translations.enable_notifications_button_text }}
                </v-btn>
                <v-btn text @click="notificationRejected">
                    {{ translations.no_thank_you_button_text }}
                </v-btn>
            </v-card-actions>

        </v-card>
    </v-dialog>

</template>

<script>

import {getToken, onMessage} from "firebase/messaging";
import colorMixin from "@/components/mixins/colorMixin.js";
import Api from "@/api.js";
import moment from 'moment';
import {mapActions} from "vuex";

const vuexModule = 'Community';
const rejectedLocalStorage = 'notificationsRejected';

export default {

    name: "EnableNotificationsDialog",

    mixins: [colorMixin],

    props: {

        actionButtonColor: {
            type: String,
            required: true,
        },
        translations: {
            type: Object,
            required: true,
        },
        panelistId: {
            type: String,
            required: true,
        },
        delay: {
            type: Number,
            required: false,
            default: 10000
        }
    },

    data() {
        return {
            dialogModel: false,
            loading: false,
        }
    },

    computed: {

        shouldAsk() {

            // Mobile browser do not support notifications
            if (!this.isPlatformSupported()) return false;

            const rejectedTill = JSON.parse(localStorage.getItem(rejectedLocalStorage));

            if (!rejectedTill) return true;

            return moment(rejectedTill.datetime).isBefore(moment());
        }
    },

    mounted() {
        if (this.isPlatformSupported()) {
            if (typeof Notification === 'undefined') return false;

            if (Notification.permission === 'default' && this.shouldAsk) {
                 this.showNotificationDialog();
            }

            if (Notification.permission === 'granted') {
                localStorage.removeItem(rejectedLocalStorage);
                this.listenToFirebaseMessages();
            }
        }
    },

    methods: {

        ...mapActions(vuexModule, [
            'getAvailableProjects',
        ]),

        isPlatformSupported() {
            return !!this.$messaging;
        },

        showNotificationDialog() {
            setTimeout(() => {
                this.dialogModel = true;
            }, this.delay);
        },

        notificationRejected() {

            const data = JSON.stringify({
                datetime: moment().add(1, 'month')
            });

            localStorage.setItem(rejectedLocalStorage, data);

            this.dialogModel = false;
        },

        askForPermission() {

            this.loading = true;

            this.notificationsToken = getToken(this.$messaging)
                .then((currentToken) => {
                    if (currentToken) {
                        this.sendToken(currentToken);
                        this.dialogModel = false;
                    } else {
                        this.deleteToken();
                    }
                }).catch((err) => {
                    console.error(err);
                    this.dialogModel = false;
                })
                .finally(() => {
                    this.loading = false;
                })
        },

        listenToFirebaseMessages() {

            onMessage(this.$messaging, (payload) => {

                const notification = new Notification(payload.notification.title, {
                    body: payload.notification.body,
                    icon: payload.notification.image,
                    data: {
                        survey_link: payload.data.survey_link
                    }
                })

                notification.onclick = function (event) {
                    notification.close();
                    window.open(payload.data.survey_link);
                };

                this.getAvailableProjects(true);
            });
        },

        sendToken(token) {

            const data = {
                type: 'browser',
                panelist_id: this.panelistId,
                token: token
            }

            Api.post('/notification-token', data)
                .then(() => {
                    this.listenToFirebaseMessages();
                });
        },
    },
}
</script>
